<div class="oauth-layout">
  <main class="oauth-layout__main">
    <article class="oauth-card">
      <header class="oauth-card__brand">
        <img
          class="oauth-card__logo"
          src="/public/logos/logo_v.svg"
          alt="Valvur"
          width="36"
          height="30"
        />
        <p class="oauth-card__tagline">
          {{ 'app.oauth.layout.tagline' | translate }}
        </p>
      </header>

      <div class="oauth-card__divider" aria-hidden="true"></div>

      <div class="oauth-card__body">
        <router-outlet />
      </div>
    </article>
  </main>
</div>
